import { Absent_getInstance3t0okspv6nz5y as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePlayerInputClass;
function SavePlayerInput() {
  if (SavePlayerInputClass === VOID) {
    class $ {
      constructor(partyId, playerId, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails) {
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.n6q_1 = partyId;
        this.o6q_1 = playerId;
        this.p6q_1 = name;
        this.q6q_1 = email;
        this.r6q_1 = badge;
        this.s6q_1 = callSignAdjective;
        this.t6q_1 = callSignNoun;
        this.u6q_1 = imageURL;
        this.v6q_1 = avatarType;
        this.w6q_1 = unvalidatedEmails;
      }
      toString() {
        return 'SavePlayerInput(partyId=' + this.n6q_1.toString() + ', playerId=' + this.o6q_1.toString() + ', name=' + this.p6q_1 + ', email=' + this.q6q_1 + ', badge=' + this.r6q_1.toString() + ', callSignAdjective=' + this.s6q_1 + ', callSignNoun=' + this.t6q_1 + ', imageURL=' + toString(this.u6q_1) + ', avatarType=' + toString(this.v6q_1) + ', unvalidatedEmails=' + toString(this.w6q_1) + ')';
      }
      hashCode() {
        var result = this.n6q_1.hashCode();
        result = imul(result, 31) + this.o6q_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.p6q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.q6q_1) | 0;
        result = imul(result, 31) + this.r6q_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.s6q_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.t6q_1) | 0;
        result = imul(result, 31) + hashCode(this.u6q_1) | 0;
        result = imul(result, 31) + hashCode(this.v6q_1) | 0;
        result = imul(result, 31) + hashCode(this.w6q_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePlayerInput()))
          return false;
        if (!this.n6q_1.equals(other.n6q_1))
          return false;
        if (!this.o6q_1.equals(other.o6q_1))
          return false;
        if (!(this.p6q_1 === other.p6q_1))
          return false;
        if (!(this.q6q_1 === other.q6q_1))
          return false;
        if (!this.r6q_1.equals(other.r6q_1))
          return false;
        if (!(this.s6q_1 === other.s6q_1))
          return false;
        if (!(this.t6q_1 === other.t6q_1))
          return false;
        if (!equals(this.u6q_1, other.u6q_1))
          return false;
        if (!equals(this.v6q_1, other.v6q_1))
          return false;
        if (!equals(this.w6q_1, other.w6q_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePlayerInput');
    SavePlayerInputClass = $;
  }
  return SavePlayerInputClass;
}
//region block: exports
export {
  SavePlayerInput as SavePlayerInput3s7vno6nbe1ix,
};
//endregion

//# sourceMappingURL=SavePlayerInput.mjs.map
